module.exports = [{"name":"sidebar.billingserviceused","icon":"fas fa-tachometer-alt","router":{"name":"BillingServiceUsed"},"activeClass":""},{"name":"sidebar.billinginvoice","icon":"far fa-file-alt","activeClass":"","submenus":[{"name":"sidebar.all","router":{"name":"BillingInvoiceList"},"activeClass":""}]},{"name":"sidebar.billinghistory","icon":"fas fa-history","router":{"name":"BillingHistory"},"activeClass":""},{"name":"sidebar.billingpaymentmethod","icon":"fas fa-credit-card","router":{"name":"BillingPaymentMethod"},"activeClass":""}]


//////////////////
// WEBPACK FOOTER
// ./src/components/apps/billing/sidebar.json
// module id = hz8i
// module chunks = 1